// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";
import Button from "@mui/material/Button";

const DownloadJSON = ({ data, fileName, label }) => {
  const downloadJSON = () => {
    const jsonData = new Blob([JSON.stringify(data)], { type: "application/json" });
    const jsonURL = URL.createObjectURL(jsonData);
    const link = document.createElement("a");
    link.href = jsonURL;
    link.download = `${fileName}.json`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Button
      style={{
        background: "rgb(23, 193, 232)",
        padding: "5px 15px 5px 15px",
        color: "#fff",
        border: "0px",
        borderRadius: "5px",
        textAlign: "right",
      }}
      onClick={downloadJSON}
    >
      {label ? label : "Download JSON"}
    </Button>
  );
};

// Typechecking props for the NotificationItem
DownloadJSON.propTypes = {
  fileName: PropTypes.string,
  data: PropTypes.array,
  label: PropTypes.string,
};

export default DownloadJSON;
